import { createAction, props } from '@ngrx/store';
import { Category, Club, ClubSearch, CompanyData, Country, SportlinkData } from './clubs.model';
import { Member } from '../Member/member.model';

// fetch 
export const fetchclublistData = createAction('[Data] fetch clublist');
export const fetchclublistSuccess = createAction('[Data] fetch clublist success', props<{ ClubListdata: Club[] }>())
export const fetchclublistFail = createAction('[Data fetch clublist failed]', props<{ error: string }>())

// fetch all
export const fetchRecords = createAction(
    '[Data] fetch records club'
);
export const fetchRecordsSuccess = createAction(
    '[Data] fetch records club success', 
    props<{ listData: Club[], total: number, isVatValid: boolean }>()
);
export const fetchRecordsFail = createAction(
    '[Data] fetch records club failure', 
    props<{ error: string }>()
);

// fetch one 
export const fetchSingleRecord = createAction(
    '[Data] fetch single record club',
    props<{id: string, gather_stats: string}>()
);
export const fetchSingleRecordSuccess = createAction(
    '[Data] fetch single record club success', 
    props<{ singleData: Club, countryList: Country[], categories: Category[], sportlinkData: SportlinkData }>()
);
export const fetchSingleRecordFail = createAction(
    '[Data] fetch single record club failure', 
    props<{ error: string }>()
);

//Search Clubs
export const searchClubs = createAction(
    '[Data] search clubs',
    props<{text: string, param?: string}>()
);
export const searchClubsSuccess = createAction(
    '[Data] search clubs success', 
    props<{ clubItems: any[], clubSearch: string, clubSearchObject:any }>()
);
export const searchClubsFail = createAction(
    '[Data] search clubs failure', 
    props<{ error: string }>()
);

//Search Company Profile
export const searchCompanyProfile = createAction(
    '[Data] search company profile',
    props<{kvknumber: string}>()
);
export const searchCompanyProfileSuccess = createAction(
    '[Data] search company profile success', 
    props<{ companyData: CompanyData }>()
);
export const searchCompanyProfileFail = createAction(
    '[Data] search company profile failure', 
    props<{ error: string }>()
);

//Vat Check
export const vatCheck = createAction(
    '[Data] vat check clubs',
    props<{text: string}>()
);
export const vatCheckSuccess = createAction(
    '[Data] vat check clubs success', 
    props<{ isVatValid: boolean, vatValue: string }>()
);
export const vatCheckFail = createAction(
    '[Data] vat check clubs failure', 
    props<{ error: string }>()
);

// Add Data
export const addRecord = createAction(
    '[Data] Add record club',
    props<{ newData: any }>()
);
export const addRecordSuccess = createAction(
    '[Data] Add record club success'
);
export const addRecordFailure = createAction(
    '[Data] Add record club failure',
    props<{ error: string }>()
);

// Update Data
export const updateRecord = createAction(
    '[Data] Update record club',
    props<{ id: string; updatedData: any }>()
);
export const updateRecordSuccess = createAction(
    '[Data] Update record club success'
);
export const updateRecordFailure = createAction(
    '[Data] Update record club failure',
    props<{ error: string }>()
);


// Update Club Installment
export const updateClubInstallment = createAction(
    '[Data] Update record club installment',
    props<{ id: string; updatedData: any }>()
);
export const updateClubInstallmentSuccess = createAction(
    '[Data] Update record club installment success'
);
export const updateClubInstallmentFailure = createAction(
    '[Data] Update record club installment failure',
    props<{ error: string }>()
);

// Delete Data
export const archiveRecord = createAction(
    '[Data] Archive record club',
    props<{ id: string }>()
);
export const archiveRecordSuccess = createAction(
    '[Data] Archive record club success'
);
export const archiveRecordFailure = createAction(
    '[Data] Archive record club failure',
    props<{ error: string }>()
);

// Delete Data
export const deleteRecord = createAction(
    '[Data] Delete record club',
    props<{ id: string }>()
);
export const deleteRecordSuccess = createAction(
    '[Data] Delete record club success'
);
export const deleteRecordFailure = createAction(
    '[Data] Delete record club failure',
    props<{ error: string }>()
);

// Import Records
export const importRecord = createAction(
    '[Data] Import record club',
    props<{ newData: any }>()
);
export const importRecordSuccess = createAction(
    '[Data] Import record club success'
);
export const importRecordFailure = createAction(
    '[Data] Import record club failure',
    props<{ error: string }>()
);

//Fetch Club Speific Members
export const fetchClubMembers = createAction(
    '[Data] fetch club members',
    props<{ clubId: string }>()
);

export const fetchClubMembersSuccess = createAction(
    '[Data] fetch club members success', 
    props<{ clubMembers: Member[] }>()
);

export const fetchClubMembersFail = createAction(
    '[Data] fetch club members failure', 
    props<{ error: string }>()
);

// Get Payment
export const getPayment = createAction(
    '[Data] Payment gateway status',
    props<{ clubId: string }>()
);
export const getPaymentSuccess = createAction(
    '[Data] Payment gateway status success',
    props<{ hasConnect: boolean|null, hasManualConnect: boolean }>()
);
export const getPaymentFailure = createAction(
    '[Data] Payment gateway status failure',
    props<{ error: string }>()
);

// Disconnect Payment
export const disconnectPayment = createAction(
    '[Data] Disconnect payment gateway',
    props<{ clubId: string }>()
);
export const disconnectPaymentSuccess = createAction(
    '[Data] Disconnect payment gateway success'
);
export const disconnectPaymentFailure = createAction(
    '[Data] Disconnect payment gateway failure',
    props<{ error: string }>()
);

// Activate Payment
export const activatePayment = createAction(
    '[Data] Activate payment gateway',
    props<{ clubId: string, isManual: number }>()
);
export const activatePaymentSuccess = createAction(
    '[Data] Activate payment gateway success'
);
export const activatePaymentFailure = createAction(
    '[Data] Activate payment gateway failure',
    props<{ error: string }>()
);

// Get Collect Master
export const getCollectMaster = createAction(
    '[Data] Collect master status',
    props<{ clubId: string }>()
);
export const getCollectMasterSuccess = createAction(
    '[Data] Collect master status success',
    props<{ hasCollectMaster: boolean|null }>()
);
export const getCollectMasterFailure = createAction(
    '[Data] Collect master status failure',
    props<{ error: string }>()
);

// Connect Collect Master
export const connectCollectMaster = createAction(
    '[Data] Connect collect master',
    props<{ clubId: string }>()
);
export const connectCollectMasterSuccess = createAction(
    '[Data] Connect collect master success',
);
export const connectCollectMasterFailure = createAction(
    '[Data] Connect collect master failure',
    props<{ error: string }>()
);

// Disconnect Collect Master
export const disconnectCollectMaster = createAction(
    '[Data] Disconnect collect master',
    props<{ clubId: string }>()
);
export const disconnectCollectMasterSuccess = createAction(
    '[Data] Disconnect collect master success'
);
export const disconnectCollectMasterFailure = createAction(
    '[Data] Disconnect collect master failure',
    props<{ error: string }>()
);

// Connect Payment
export const connectPayment = createAction(
    '[Data] Connect club payment gateway',
    props<{isManual?: boolean, clubId:string}>()
);
export const connectPaymentSuccess = createAction(
    '[Data] Connect club payment gateway success',
    props<{connectUrl: string, connectLoading: boolean}>()
);
export const connectPaymentFailure = createAction(
    '[Data] Connect club payment gateway failure',
    props<{ error: string }>()
);


// Complete Connection Payment
export const completeConnectionPayment = createAction(
    '[Data] Complete connection club payment gateway',
    props<{ data: any }>()
);
export const completeConnectionPaymentSuccess = createAction(
    '[Data] Complete connection club payment gateway success'
);
export const completeConnectionPaymentFailure = createAction(
    '[Data] Complete connection club payment gateway failure',
    props<{ error: string }>()
);

//Reset State
export const resetState = createAction(
    '[Data] reset state club',
);